"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var thLocaleData = require("i18next-icu/locale-data/th");
exports.default = thLocaleData;
//# sourceMappingURL=th.js.map